(function () {
  'use strict';

  var drawer = document.getElementById('mobNavDrawer');
  if (!drawer) return;

  // Luxe already sets aria-modal="true". Add role and label.
  drawer.setAttribute('role', 'dialog');
  drawer.setAttribute('aria-label', 'Navigation menu');

  // Hidden live region -- screen readers announce open/close state.
  var liveRegion = document.createElement('div');
  liveRegion.className = 'visually-hidden';
  liveRegion.setAttribute('aria-live', 'polite');
  liveRegion.setAttribute('aria-atomic', 'true');
  document.body.appendChild(liveRegion);

  function announce(msg) {
    liveRegion.textContent = '';
    // Brief delay so the DOM mutation registers as a new announcement.
    setTimeout(function () { liveRegion.textContent = msg; }, 50);
  }

  // Focusable selector used for Tab cycling.
  var FOCUSABLE_SELECTORS = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function getFocusable() {
    return Array.from(drawer.querySelectorAll(FOCUSABLE_SELECTORS)).filter(
      function (el) { return el.offsetParent !== null; }
    );
  }

  function onKeydown(e) {
    // ESC closes the drawer by triggering Luxe's existing close button.
    if (e.key === 'Escape') {
      var closeBtn = document.getElementById('mobNavDrawerClose');
      if (closeBtn) closeBtn.click();
      return;
    }

    if (e.key !== 'Tab') return;

    var focusable = getFocusable();
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  // Watch Luxe's .open class toggle on the drawer.
  // Luxe already restores focus to the trigger button on close via lastFocusedButton.
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName !== 'class') return;
      var isOpen = drawer.classList.contains('open');
      if (isOpen) {
        drawer.addEventListener('keydown', onKeydown);
        announce('Navigation menu opened');
      } else {
        drawer.removeEventListener('keydown', onKeydown);
        announce('Navigation menu closed');
      }
    });
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

}());
